/** Slug amigável para URLs de projeto: "titulo-do-projeto-8". O id no fim
 * garante que o link nunca quebra mesmo que o título mude depois. */
export function getProjectSlug(project) {
  const base = (project?.title || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return base ? `${base}-${project.id}` : String(project.id);
}

/** Extrai o id numérico do fim de um slug (ou aceita um id puro, para compatibilidade). */
export function getProjectIdFromSlug(slug) {
  const match = String(slug).match(/(\d+)$/);
  return match ? match[1] : slug;
}
